import Modal from '@design/objects/modal/twig/assets'
import Tooltip from '@design/objects/tooltip/twig/assets/index'

export default class BookingReward {
  element!: HTMLElement
  modal?: Modal
  private controller = new AbortController()
  private destroyTooltip: () => void = () => undefined

  constructor(element: string | HTMLElement) {
    let el: HTMLElement | string | null = element

    if (typeof element === 'string') {
      el = document.querySelector(element) as HTMLElement
    }

    if (!el || typeof el === 'string') {
      return
    }

    this.element = el

    this.destroyTooltip = Tooltip(this.element.querySelectorAll<HTMLElement>('[data-tooltip-id]'))

    const modalEl = this.element.querySelector<HTMLElement>('.o-booking-reward__modal')

    if (modalEl) {
      this.modal = new Modal(modalEl)

      this.element.addEventListener(
        'click',
        () => {
          this.modal?.open()
        },
        { signal: this.controller.signal }
      )
    }
  }

  destroy(): void {
    this.destroyTooltip()
    this.controller.abort()
  }
}
